/** @format */

import PropTypes from "prop-types";
import { formatCurrency } from "../../../utility/currencyUtils";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
	Avatar,
	Box,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography,
} from "@mui/material";
import SkeletonPayoutCard from "./SkeletonPayoutCard";
import { CardWrapper } from "./styles";
import { colors } from "../../../utility/types/constant";

interface PayOutCardProps {
	isLoading: boolean;
	totalPayOuts: number;
	currency?: string;
}

const PayOutCard = (props: PayOutCardProps) => {
	const { isLoading, totalPayOuts, currency = "usd" } = props;

	const theme = useTheme();

	return (
		<>
			{isLoading ? (
				<SkeletonPayoutCard />
			) : (
				<CardWrapper border={false} content={false}>
					<Box sx={{ p: 2 }}>
						<List sx={{ py: 0 }}>
							<ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
								<ListItemAvatar>
									<Avatar
										variant="rounded"
										sx={{
											...theme.typography,
											...theme.typography,
											backgroundColor: theme.palette.primary as any[800],
											color: "#fff",
										}}>
										<img
											style={{ backgroundColor: colors.white }}
											src="/assets/icons/payout-icon.png"
											alt="earning icon"
										/>
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									sx={{
										py: 0,
										mt: 0.45,
										mb: 0.45,
									}}
									primary={
										<Typography
											variant="h4"
											sx={{
												color: "#fff",
												fontFamily: "'Montserrat', sans-serif",
												fontWeight: 900,
											}}>
											{formatCurrency(totalPayOuts, currency)}
										</Typography>
									}
									secondary={
										<Typography
											variant="subtitle2"
											sx={{
												color: "#fff",
												mt: 0.25,
												fontFamily: "'Montserrat', sans-serif",
												fontWeight: 999,
											}}>
											Your Total Payout
										</Typography>
									}
								/>
							</ListItem>
						</List>
					</Box>
				</CardWrapper>
			)}
		</>
	);
};

PayOutCard.propTypes = {
	isLoading: PropTypes.bool,
	totalPayOuts: PropTypes.number,
};

export default PayOutCard;
